export default __webpack_public_path__ + "static/media/RoundGradExamining.0d5fbceb.svg";